import styled from "styled-components"

const ButtonList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5em;
`

export default ButtonList
